import React from 'react';

import { GicAnywhere } from '@atlassian/gic-anywhere';

import { SidePanelBody } from '@confluence/side-panel';

import type { IssueCreateSidePanelBodyProps } from './__types__/IssueCreateSidePanelBody';

const noop = () => {};

export const IssueCreateSidePanelBody = ({ onClose }: IssueCreateSidePanelBodyProps) => {
	return (
		<SidePanelBody>
			<GicAnywhere
				consumer="confluence-highlight-issue-create"
				onSuccess={noop}
				onClose={onClose}
				onFailure={noop}
			/>
		</SidePanelBody>
	);
};
